// Renders every available permission as a toggle row, grouped by category.
// Controlled component: `selected` is an array of keys, `onChange` receives the new array.
export default function PermissionSwitchboard({ allPermissions, selected, onChange, disabled }) {
  const groups = allPermissions.reduce((acc, p) => {
    acc[p.group] = acc[p.group] || [];
    acc[p.group].push(p);
    return acc;
  }, {});

  const toggle = (key) => {
    if (disabled) return;
    const next = selected.includes(key)
      ? selected.filter((k) => k !== key)
      : [...selected, key];
    onChange(next);
  };

  return (
    <div style={styles.board}>
      {Object.entries(groups).map(([group, items]) => (
        <div key={group} style={styles.group}>
          <div style={styles.groupLabel}>{group}</div>
          {items.map((p) => {
            const on = selected.includes(p.key);
            return (
              <div key={p.key} style={styles.row}>
                <span style={styles.rowLabel}>{p.label}</span>
                <button
                  type="button"
                  role="switch"
                  aria-checked={on}
                  onClick={() => toggle(p.key)}
                  disabled={disabled}
                  style={{
                    ...styles.switch,
                    background: on ? "var(--signal)" : "var(--line)",
                    opacity: disabled ? 0.5 : 1,
                  }}
                >
                  <span
                    style={{
                      ...styles.knob,
                      transform: on ? "translateX(16px)" : "translateX(0px)",
                    }}
                  />
                </button>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

const styles = {
  board: { border: "1px solid var(--line)", borderRadius: "var(--radius)", overflow: "hidden" },
  group: { borderBottom: "1px solid var(--line)" },
  groupLabel: {
    fontSize: 11,
    letterSpacing: 0.4,
    color: "var(--slate-500)",
    padding: "10px 16px 4px",
    fontWeight: 600,
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
  },
  rowLabel: { fontSize: 14, color: "var(--ink)" },
  switch: {
    width: 34,
    height: 18,
    borderRadius: 10,
    border: "none",
    position: "relative",
    padding: 0,
  },
  knob: {
    position: "absolute",
    top: 2,
    left: 2,
    width: 14,
    height: 14,
    borderRadius: "50%",
    background: "#fff",
    transition: "transform 120ms ease",
  },
};
